import OMobileMapQr from './o-mobile-map-qr';

export default OMobileMapQr;